import { memo, useMemo } from "react";
import { Card } from "@aidron/aidron-ds";
import { OuterCardHeading } from "../../OuterCardHeading/OuterCardHeading";
import { LabelAndNumberView } from "../../../../../../components/SharedComponents/sharedComponents.index";
import { CustomHeading } from "../../../../../../components/StyledComponents/styleComponents.index";
import PropTypes from 'prop-types';

const InnerCard = memo(function InnerCard({ ctx }) {
  const { title, data } = ctx || {};
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '0.3rem',
      inlineSize: '45%',
      maxInlineSize: '100%',
      blockSize: '100%'
    }}>
      <CustomHeading 
        maxInlineSize={"100%"}
        fontSize={['0.5rem', '0.8rem', '1.3rem']}
        inlineSize="fit-content" 
        weight="bold" 
        color="mediumGrey">
        {title}
      </CustomHeading>
      <Card 
        style={{ 
          padding: "1rem 0.5rem", 
          blockSize: "100%", 
          inlineSize: "100%", 
        }}>
        <div style={{ 
          alignItems: "center",
          display: 'flex',
          flexDirection: 'column',
          gap: '4.5rem',
          inlineSize: '100%',
          maxInlineSize: '100%',
          blockSize: '100%',
          maxBlockSize: '100%',
          margin: "auto" 
        }}>
          {data?.map((datum) => (
            <LabelAndNumberView
              ctx={{
                heading: datum.heading,
                number: datum.number,
                numberText: datum.numberText,
                text: datum.text,
                link: datum.link
              }}
              key={datum.heading}/>
          ))}
        </div>
      </Card>
    </div>
  );
});

export const UpperCardModel = memo(function UpperCardModel({ ctx, uiState }) {
  const { title, text, leftCard, rightCard } = ctx || {};
  const { adjustmentPlan = false } = uiState || {};

  const leftCardCtx = useMemo(
    () => ({ title: leftCard?.title, data: leftCard?.data }),
    [leftCard?.title, leftCard?.data]
  );

  const rightCardCtx = useMemo(
    () => ({ title: rightCard?.title, data: rightCard?.data }),
    [rightCard?.title, rightCard?.data]
  );

  return (
    <div style={{ marginBlock: '2%', inlineSize: '100%', blockSize: '100%' }}>
      <Card style={{ padding: "2rem", blockSize: "100%" }}>
        <OuterCardHeading ctx={{ title: title.toUpperCase(), text: text }} uiState={{ adjustmentPlan: adjustmentPlan }} />
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          fleWrap: 'wrap',
          justifyContent: 'space-around',
          gap: '5%',
          blockSize: '100%',
          paddingBlockEnd: '0.6rem'
        }}>
          <InnerCard ctx={leftCardCtx}/>
          <InnerCard ctx={rightCardCtx}/>
        </div>
      </Card>
    </div>
  );
});

UpperCardModel.propTypes = { ctx: PropTypes.shape(), uiState: PropTypes.shape() };
InnerCard.propTypes = { ctx: PropTypes.shape() };